import { memo } from 'react';

import type { IconProperties } from './types';

/**
 * Blox-Design plan toolbar view tabs (node 75644:12533).
 */
export const PlanViewModeChartTableIcon = memo(
  ({ width = 16, height = 16, color = 'currentColor' }: IconProperties) => (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <path
        d='M15.8047 15.8047C15.6747 15.9347 15.504 16 15.3333 16C15.1627 16 14.992 15.9347 14.862 15.8047L10.8827 11.8253C9.73267 12.7667 8.26467 13.3333 6.66667 13.3333C2.99067 13.3333 0 10.3427 0 6.66667C0 2.99067 2.99067 0 6.66667 0C7.83867 0 8.99133 0.308667 10.0007 0.892C10.3193 1.07667 10.4287 1.48467 10.2433 1.80333C10.12 2.01667 9.896 2.136 9.666 2.136C9.55267 2.136 9.438 2.10733 9.33267 2.04667C8.52667 1.58 7.60467 1.33333 6.66667 1.33333C3.726 1.33333 1.33333 3.726 1.33333 6.66667C1.33333 7.44467 1.50467 8.18267 1.806 8.84933L4.33867 5.81C4.58 5.51933 4.936 5.34333 5.31333 5.326C5.688 5.30933 6.06133 5.45133 6.32933 5.72L7.61467 7.00533L13.4913 0.226667C13.7327 -0.0526667 14.154 -0.0813333 14.4313 0.158C14.71 0.398667 14.7413 0.82 14.5007 1.09867L8.64733 7.876C8.40333 8.15867 8.04933 8.32867 7.67533 8.34267C7.304 8.352 6.93667 8.21267 6.672 7.948L5.38667 6.66267L2.54467 10.046C3.52333 11.238 5.008 11.9993 6.66667 11.9993C9.60733 11.9993 12 9.60667 12 6.666C12 6.566 11.9967 6.46667 11.9913 6.368C11.972 6 12.2547 5.68667 12.622 5.66667C12.9867 5.64 13.3033 5.92933 13.3233 6.29667C13.33 6.41867 13.3333 6.542 13.3333 6.66533C13.3333 8.264 12.7667 9.732 11.8253 10.8813L15.8047 14.8607C16.0653 15.1213 16.0653 15.5427 15.8047 15.8033V15.8047Z'
        fill={color}
      />
    </svg>
  ),
);

export const PlanViewModeChartIcon = memo(
  ({ width = 16, height = 16, color = 'currentColor' }: IconProperties) => (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <path
        d='M15.3333 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V0.666667C1.33333 0.489856 1.2631 0.320286 1.13807 0.195262C1.01305 0.0702379 0.843478 0 0.666667 0C0.489856 0 0.320286 0.0702379 0.195262 0.195262C0.0702379 0.320286 0 0.489856 0 0.666667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H15.3333C15.5101 16 15.6797 15.9298 15.8047 15.8047C15.9298 15.6797 16 15.5101 16 15.3333C16 15.1565 15.9298 14.987 15.8047 14.8619C15.6797 14.7369 15.5101 14.6667 15.3333 14.6667Z'
        fill={color}
      />
      <path
        d='M3.99967 13.333C4.17649 13.333 4.34605 13.2628 4.47108 13.1377C4.5961 13.0127 4.66634 12.8432 4.66634 12.6663V7.99967C4.66634 7.82286 4.5961 7.65329 4.47108 7.52827C4.34605 7.40325 4.17649 7.33301 3.99967 7.33301C3.82286 7.33301 3.65329 7.40325 3.52827 7.52827C3.40325 7.65329 3.33301 7.82286 3.33301 7.99967V12.6663C3.33301 12.8432 3.40325 13.0127 3.52827 13.1377C3.65329 13.2628 3.82286 13.333 3.99967 13.333Z'
        fill={color}
      />
      <path
        d='M6.66699 6.66667V12.6667C6.66699 12.8435 6.73723 13.013 6.86225 13.1381C6.98728 13.2631 7.15685 13.3333 7.33366 13.3333C7.51047 13.3333 7.68004 13.2631 7.80506 13.1381C7.93009 13.013 8.00033 12.8435 8.00033 12.6667V6.66667C8.00033 6.48986 7.93009 6.32029 7.80506 6.19526C7.68004 6.07024 7.51047 6 7.33366 6C7.15685 6 6.98728 6.07024 6.86225 6.19526C6.73723 6.32029 6.66699 6.48986 6.66699 6.66667Z'
        fill={color}
      />
      <path
        d='M10 8.66667V12.6667C10 12.8435 10.0702 13.013 10.1953 13.1381C10.3203 13.2631 10.4899 13.3333 10.6667 13.3333C10.8435 13.3333 11.013 13.2631 11.1381 13.1381C11.2631 13.013 11.3333 12.8435 11.3333 12.6667V8.66667C11.3333 8.48986 11.2631 8.32029 11.1381 8.19526C11.013 8.07024 10.8435 8 10.6667 8C10.4899 8 10.3203 8.07024 10.1953 8.19526C10.0702 8.32029 10 8.48986 10 8.66667Z'
        fill={color}
      />
      <path
        d='M13.333 5.99967V12.6663C13.333 12.8432 13.4032 13.0127 13.5283 13.1377C13.6533 13.2628 13.8229 13.333 13.9997 13.333C14.1765 13.333 14.3461 13.2628 14.4711 13.1377C14.5961 13.0127 14.6663 12.8432 14.6663 12.6663V5.99967C14.6663 5.82286 14.5961 5.65329 14.4711 5.52827C14.3461 5.40325 14.1765 5.33301 13.9997 5.33301C13.8229 5.33301 13.6533 5.40325 13.5283 5.52827C13.4032 5.65329 13.333 5.82286 13.333 5.99967Z'
        fill={color}
      />
      <path
        d='M3.99953 5.99962C4.17633 5.99958 4.34587 5.92932 4.47087 5.80429L6.86153 3.41362C6.9886 3.29257 7.15737 3.22505 7.33287 3.22505C7.50836 3.22505 7.67713 3.29257 7.8042 3.41362L9.2522 4.86162C9.62725 5.23656 10.1359 5.44719 10.6662 5.44719C11.1965 5.44719 11.7051 5.23656 12.0802 4.86162L15.8042 1.13762C15.9256 1.01189 15.9928 0.843484 15.9913 0.668686C15.9898 0.493888 15.9197 0.32668 15.7961 0.203075C15.6725 0.0794693 15.5053 0.00935665 15.3305 0.0078377C15.1557 0.00631876 14.9873 0.073515 14.8615 0.194954L11.1375 3.91829C11.0125 4.04327 10.843 4.11348 10.6662 4.11348C10.4894 4.11348 10.3199 4.04327 10.1949 3.91829L8.74687 2.47095C8.37181 2.09601 7.86319 1.88538 7.33287 1.88538C6.80254 1.88538 6.29392 2.09601 5.91887 2.47095L3.5282 4.86162C3.43499 4.95486 3.37152 5.07363 3.34581 5.20293C3.3201 5.33223 3.3333 5.46626 3.38375 5.58806C3.43419 5.70986 3.51962 5.81397 3.62923 5.88722C3.73883 5.96048 3.8677 5.99959 3.99953 5.99962Z'
        fill={color}
      />
    </svg>
  ),
);

export const PlanViewModeTableIcon = memo(
  ({ width = 16, height = 16, color = 'currentColor' }: IconProperties) => (
    <svg
      width={width}
      height={height}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      aria-hidden
    >
      <path
        d='M12.6667 1.33301H3.33333C1.49533 1.33301 0 2.82834 0 4.66634V11.333C0 13.171 1.49533 14.6663 3.33333 14.6663H12.6667C14.5047 14.6663 16 13.171 16 11.333V4.66634C16 2.82834 14.5047 1.33301 12.6667 1.33301ZM1.33333 6.66634H4V9.33301H1.33333V6.66634ZM5.33333 6.66634H14.6667V9.33301H5.33333V6.66634ZM14.6667 4.66634V5.33301H5.33333V2.66634H12.6667C13.7693 2.66634 14.6667 3.56367 14.6667 4.66634ZM3.33333 2.66634H4V5.33301H1.33333V4.66634C1.33333 3.56367 2.23067 2.66634 3.33333 2.66634ZM1.33333 11.333V10.6663H4V13.333H3.33333C2.23067 13.333 1.33333 12.4357 1.33333 11.333ZM12.6667 13.333H5.33333V10.6663H14.6667V11.333C14.6667 12.4357 13.7693 13.333 12.6667 13.333Z'
        fill={color}
      />
    </svg>
  ),
);
